import React from "react";
import { useParams } from "react-router-dom";

import { Breadcrumbs } from "components";
import { NameId, PendFrom } from "types";

import AddPendForm from "./addPendForm";

type AddPendProps = {
	nameId: NameId;
	pendFrom: PendFrom;
	pages?: any[];
};

const AddPend = ({ nameId, pendFrom, pages = [] }: AddPendProps) => {
	const params = useParams<{ id: string }>();
	return (
		<>
			<Breadcrumbs
				pages={[
					...pages,
					{
						title: "Add Pend",
					},
				]}
			/>
			<div className="forms-container mt-5">
				<AddPendForm
					id={params.id}
					nameId={nameId}
					pendFrom={pendFrom}
				/>
			</div>
		</>
	);
};

export default AddPend;
